export const GET_SCHOOL_LAYOUTS = 'schoolLayouts/';
export const GET_SCHOOL_ARTICLE_LAYOUTS = 'schoolArticleLayouts/';
export const EDIT_SCHOOL_LAYOUT = 'schoolLayouts/';

export const GET_SCHOOL_ARTICLES = 'schoolArticles/';
export const GET_SCHOOL_ARTICLE = 'schoolarticle/';
export const GET_SCHOOL_ARTICLES_PENDING = 'schoolArticles/pending/';
export const GET_SCHOOL_ARTICLES_SCHEDULED = 'schoolArticles/scheduled/';
export const GET_SCHOOL_ARTICLES_PUBLISHED = 'schoolArticles/published/';
export const CREATE_SCHOOL_ARTICLE = 'schoolArticles/';
export const EDIT_SCHOOL_ARTICLE = 'schoolarticle/';
export const REMOVE_SCHOOL_ARTICLE = 'schoolarticle/';

export const AUTHENTICATE = 'schools/accessToken/';

export const GET_SCHOOLS = 'schools/';
export const GET_SCHOOL_CLASSES = 'schoolClasses/';
export const GET_SCHOOL_CLASS = 'schoolclass/';
export const CREATE_SCHOOL_CLASS = 'schoolClasses';
export const EDIT_SCHOOL_CLASS = 'schoolclass/';
export const REMOVE_SCHOOL_CLASS = 'schoolclass/';

export const GET_SCHOOL_FILES = 'schoolFiles/';
export const GET_SCHOOL_FILE = 'schoolfile/';
export const CREATE_SCHOOL_FILE = 'schoolFiles/';
export const EDIT_SCHOOL_FILE = 'schoolfile/';
export const REMOVE_SCHOOL_FILE = 'schoolfile/';
